// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex } from '@iheartjane/reefer';
import { shadows } from '@iheartjane/reefer-emotion';

export const SpecialsWrapper = styled(Flex)<{ headless?: boolean }>(
  ({ theme, headless }) => ({
    boxShadow: headless ? 'none' : shadows.divider,
    backgroundColor: theme.colors.grays.white,
  })
);
